// extracted by mini-css-extract-plugin
export default {"employeeHeadcountRange":"CompanyHeadcountFilter_employeeHeadcountRange__j58uh","headcountInputContainer":"CompanyHeadcountFilter_headcountInputContainer__bbOLC"};